var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayNextIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "24 20 109 127",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.playNextIcon{fill:none;stroke:currentColor;stroke-width:6;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "playNextIcon",
    points: "26.9,141.2 26.8,83.2 26.7,25.2 77,54.1 127.3,83.1 77.1,112.1  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "playNextIcon",
    x1: 129.5,
    y1: 25.2,
    x2: 129.5,
    y2: 141.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayNextIcon);
export default __webpack_public_path__ + "static/media/play-next-icon.4fcdd2f69864e0f6d7b4b603f83eb606.svg";
export { ForwardRef as ReactComponent };